export const MIN_PHONE_LEN = 10;
export const MAX_PHONE_LEN = 11;